import Vue from '@/shared/node_modules/vue';
import VueRouter from '@/shared/node_modules/vue-router';
import store from '@/shared/core/store';
import { LocalStorage } from '@/shared/core/localStorage';
import { isEmbedded, notifyScrollTop } from '@/shared/core/embed';
import { SettingsService } from '@/shared/core/services/configService';
Vue.use(VueRouter);

/************************************************************
 meta options:
 public default false
 layout [secure | insecure ] default insecure

 SEO: indexing is fail-closed on the backend (SeoService in
 crm/api/v_medkus — PublicPathPrefixes). A new PRIVATE route is
 noindexed by default; a new PUBLIC route that should be indexed
 must be added to PublicPathPrefixes (and to the sitemap there).
/************************************************************/
const routes = [

    { path: '/', name: "index", meta: { public: true }, component: require('../pages/index.vue').default, props: true },
    { path: '/changePass', name: "changepass", meta: { public: false }, component: require('@/shared/pages/changePasswordPage.vue').default, props: true },
    { path: '/shop', name: "shop", meta: { public: true }, component: require('@/shared/pages/shopPage.vue').default, props: true },
    { path: '/shop/:id', name: "shop-product", meta: { public: true }, component: require('@/shared/pages/productPage.vue').default, props: true },
    { path: '/blog', name: "blog", meta: { public: true }, component: require('@/shared/pages/blogPage.vue').default, props: true },
    { path: '/post/:id', name: "post", meta: { public: true }, component: require('@/shared/pages/postPage.vue').default, props: true },
    { path: '/checkout', name: "checkout", meta: { public: true }, component: require('@/shared/pages/checkoutPage.vue').default, props: true },
    { path: '/debts', name: "debts", meta: { public: false }, component: require('@/shared/pages/debtsPage.vue').default, props: true },
    { path: '/cz/ok/', name: "payment-ok", meta: { public: true }, component: require('@/shared/pages/paymentOkPage.vue').default, props: true },
    { path: '/cz/ko/', name: "payment-ko", meta: { public: true }, component: require('@/shared/pages/paymentKoPage.vue').default, props: true },
    { path: '/netpay-callback/', name: "netpay-callback", meta: { public: true }, component: require('@/shared/pages/netPay3dsPayment.vue').default, props: true },
    { path: '/stripe-callback/', name: "stripe-callback", meta: { public: true }, component: require('@/shared/pages/stripeRedirectPayment.vue').default, props: true },
    { path: '/customer/reset-password/:token', name: "reset-password", meta: { public: true }, component: require('@/shared/pages/resetPasswordPage.vue').default, props: true },
    { path: '/customer/activate/:token/:ismedkus(\\d+)?', name: "activate", meta: { public: true }, component: require('@/shared/pages/activatePage.vue').default, props: true },
    { path: '/passReset/ok/', name: "pass-reset-ok", meta: { public: true }, component: require('@/shared/pages/passResetOkPage.vue').default, props: true },
    { path: '/privacy', name: "privacy", meta: { public: true, layout: "legal" }, component: require('@/shared/pages/privacyPage.vue').default, props: true },
    { path: '/wayver', name: "wayver", meta: { public: true, layout: "legal" }, component: require('@/shared/pages/wayverPage.vue').default, props: true },
    { path: '/cookies', name: "cookies", meta: { public: true, layout: "legal" }, component: require('@/shared/pages/cookiesPage.vue').default, props: true },
    { path: '/generalConditions', name: "general-conditions", meta: { public: true, layout: "legal" }, component: require('@/shared/pages/generalConditionsPage.vue').default, props: true },
    { path: '/activity/:id', name: "activity", meta: { public: true }, component: require('@/shared/crm/components/activities/activityPage.vue').default, props: true },

    //courses
    { path: '/courses', name: "courses", meta: { public: false }, component: require('../pages/coursesPage.vue').default, props: true },
    { path: '/courses/:id', name: "course", meta: { public: false }, component: require('../pages/coursePage.vue').default, props: true },
    { path: '/courses/:id/lessons/:lessonId', name: "lesson", meta: { public: false }, component: require('../pages/lessonPage.vue').default, props: true },

    //bookings
    //{ path: '/bookings-menu', name: "bookings-menu", meta: { public: true }, component: require('@/shared/bookings/bookingsMenuPage.vue').default, props: true },
    { path: '/bookings-byplace/:bookingTypeId?', name: "bookings-byplace", meta: { public: true }, component: require('@/shared/bookings/bookingsByPlacePage.vue').default, props: true },
    { path: '/booking-visual/:bookingId/:templateId', name: "booking-visual", meta: { public: false }, component: require('@/shared/bookings/bookingVisualPage.vue').default, props: true },
    { path: '/customer-bookings', name: "customer-bookings", meta: { public: false }, component: require('@/shared/bookings/myBookingsPage.vue').default, props: true },
    { path: '/customer-orders', name: "customer-orders", meta: { public: false }, component: require('@/shared/pages/myOrdersPage.vue').default, props: true },
    { path: '/customer-orders/:id', name: "customer-order", meta: { public: false }, component: require('@/shared/pages/myOrderPage.vue').default, props: true },
    { path: '/bookings/:bookingTypeId?', name: "bookings", meta: { public: true }, component: require('@/shared/bookings/bookingsPage.vue').default, props: true },
    { path: '/bookingtypes', name: "bookingtypes", meta: { public: true }, component: require('@/shared/bookings/bookingTypesPage.vue').default, props: true },
    { path: '/programs', name: "programs", meta: { public: true }, component: require('@/shared/bookings/programPacksPage.vue').default, props: true },
    { path: '/programs/:id', name: "program", meta: { public: true }, component: require('@/shared/bookings/programPackPage.vue').default, props: true },
    { path: '/programs/:id/book', name: "program-book", meta: { public: true }, component: require('@/shared/bookings/programPackBookPage.vue').default, props: true },
    { path: '/customer-programs', name: "customer-programs", meta: { public: false }, component: require('@/shared/bookings/myProgramPacksPage.vue').default, props: true },
    { path: '/customer-programs/:id', name: "customer-program", meta: { public: false }, component: require('@/shared/bookings/myProgramPackPage.vue').default, props: true },
    { path: '/customer-reports', name: "customer-reports", meta: { public: false }, component: require('@/shared/bookings/myReportsPage.vue').default, props: true },
    { path: '/customer-vouchers', name: "customer-vouchers", meta: { public: false }, component: require('@/shared/pages/myVouchersPage.vue').default, props: true },
    { path: '/customer-comms', name: "customer-comms", meta: { public: false }, component: require('@/shared/pages/myCommsPage.vue').default, props: true },
    { path: '/customer-comms/emails/:id', name: "customer-comm", meta: { public: false }, component: require('@/shared/pages/myEmailPage.vue').default, props: true },
    { path: '/customer-surveys', name: "customer-surveys", meta: { public: false }, component: require('@/shared/pages/mySurveysPage.vue').default, props: true },
    { path: '/customer-surveys/:id', name: "customer-survey", meta: { public: false }, component: require('@/shared/pages/mySurveyPage.vue').default, props: true },
    { path: '/account', name: "account", meta: { public: false }, component: require('../pages/accountPage.vue').default, props: true },

    { path: '/auto-login', name: "auto-login", meta: { public: true, layout: "clean" }, component: require('@/shared/pages/czAutoLoginPage.vue').default, props: true },
    { path: '/sign-documents', name: "sign-documents", meta: { public: true, layout: "clean" }, component: require('../pages/signDocumentsPage.vue').default, props: true },
    { path: '/survey/preview', name: "survey-preview", meta: { public: true, layout: "clean" }, component: require('../pages/surveyAnswerPage.vue').default, props: true },
    { path: '/survey/:token', name: "survey", meta: { public: true, layout: "clean" }, component: require('../pages/surveyAnswerPage.vue').default, props: true },
    { path: '/booking-confirm/:token', name: "booking-confirm", meta: { public: true, layout: "clean" }, component: require('../pages/bookingConfirmPage.vue').default, props: true },
    { path: '/treasure/:treasureId', name: "treasure", meta: { public: false }, component: require('../pages/treasurePage.vue').default, props: true },
];



export const router = new VueRouter({
    mode: 'history',
    routes: routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

router.afterEach((to, from) => {
    // Reset to the tenant title; pages with their own title set it on mounted.
    new SettingsService().setPageTitle();

    // Embebido: al cambiar de paso pedir al host que lleve la vista al iframe.
    if (isEmbedded() && to.path !== from.path) {
        notifyScrollTop();
    }
});

router.beforeEach(async (to, from, next) => {
    const loading = from.name === '' || from.name === null;
    if (to.path != from.path) {
        Vue.prototype.$prevRoute = from;
    }

    Vue.prototype.$last = from.fullPath;

    // Embebido: la home de marketing nunca se muestra, la entrada es /bookingtypes.
    if (isEmbedded() && to.path === '/') {
        return next({ path: '/bookingtypes' });
    }

    if (to.hash.indexOf("#/cz/ok") !== -1) {
        return next({ path: '/cz/ok' });
    }
    if (to.hash.indexOf("#/cz/ko") !== -1) {
        return next({ path: '/cz/ko' });
    }

    if (!to.meta || to.meta.public !== true) {
        const t = LocalStorage.getWithTimeout("ctk");
        const isLogged = t !== undefined && t !== null && t !== '';
        if (isLogged) {
            return next();
        }

        if (store.state.loginIsOpen !== true) {
            store.commit('openLogin', to.fullPath);
        }

        if (loading) {
            return next({ path: '/' });
        }

        return next(from.fullPath);
    }

    return next();
});
